<script>
import { mapActions, mapState } from 'vuex'

import ButtonExtender from './button-extender.vue'
import ButtonTerminator from './button-terminator.vue'
import ReservationClock from './reservation-clock.vue'

export default {
  props: ['extensions_enabled'],

  data () {
    return {
      current_transaction_id: 0,
      current_termination_url: null
    }
  },

  created () {
    this.$watch('reservation_transaction', function (transaction) {
      // Set reservation transaction id to initial value
      if(transaction && this.current_transaction_id == 0) {
        this.current_transaction_id = transaction.id
        this.current_termination_url = transaction.attributes.transaction_termination_url
      }

      // Redirect if reservation transaction id has changed from initial value
      if(! this.is_terminating && transaction && this.current_transaction_id != transaction.id) {
        window.location.reload(true)
      }

      // Redirect if the reservation no longer exists on the server
      if (! this.is_terminating && ! transaction && window.location.href.indexOf('/connect') > -1) {
        window.location.reload(true)
      }
    })
  },

  components: {
    ButtonExtender,
    ButtonTerminator,
    ReservationClock,
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      is_terminating: state =>
        state.reservation.current.is_terminating
    }),

    isVisible: function () {
      return this.reservation_transaction &&
        this.current.is_visible
    },
    isExpiring: function () {
      return this.current.is_expiring &&
        this.extensions_enabled
    }
  }
}
</script>

<template>
  <div class="lab-controls">
    <div v-if="isVisible">
      <reservation-clock></reservation-clock>
      <div class="nav">
        <button-extender v-if="isExpiring" is_small="true"></button-extender>&nbsp;
        <button-terminator is_small="true"></button-terminator>
      </div>
    </div>
  </div>
</template>
